import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GetCountryService, GetFordExperienceUrlService } from '@core/services';
import { inject } from '@angular/core';
import { ButtonLibComponent } from "@components/atoms";

@Component({
  selector: 'lib-my-ford-experience',
  standalone: true,
  imports: [TranslateModule, ButtonLibComponent],
  templateUrl: './my-ford-experience.component.html',
  styleUrls: ['./my-ford-experience.component.scss'],
})

export class MyFordExperienceComponent {
  readonly #getCountryService = inject(GetCountryService);
  readonly #getFordExperienceUrlService = inject(GetFordExperienceUrlService);

  redirect() {
    const countryCode = this.#getCountryService.getCountry();
    const urlCountry = this.#getFordExperienceUrlService.getUrl(countryCode, 'experiences');
    window.open(urlCountry);
  }
}
